import makeStyles from '@mui/styles/makeStyles';
import {
  font,
  mobile,
  fieldColor,
  buttonPurple,
  onInputHoverPurple,
  onInputFocusPurple,
  onHoverButtonPurple,
} from '../../../Styles/styles';

const editFranchiseModalStyles = makeStyles((theme) => ({
  editFranchiseModalOpenButton: {
    transform: 'unset',
    position: 'unset',
  },
  editFranchiseModalHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  editFranchiseModalCloseButton: {
    transform: 'unset',
    position: 'unset',
    // Breakpoint for Mobile
    [theme.breakpoints.down(mobile)]: {
      padding: 'unset',
    },
  },
  editFranchiseModalContainer: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      maxWidth: '500px',
      padding: '24px',
      width: '70%',
      // Breakpoint for Mobile
      [theme.breakpoints.down(mobile)]: {
        margin: 'unset',
        width: '80%',
      },
    },

  },
  editFranchiseModalContent: {
    padding: 'unset',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: onInputFocusPurple,
    },
  },
  editFranchiseModalHeader: {
    padding: 'unset',
    '& h2': {
      fontSize: '24px',
      fontFamily: font,
      fontWeight: '600',
      color: fieldColor,
      letterSpacing: '0',
    },
  },
  editFranchiseModalSubheader: {
    margin: 'unset',
    fontSize: '14px',
    fontFamily: font,
    lineHeight: '20px',
    letterSpacing: '0',
    padding: '12px 0px 24px 0px',
  },
  editFranchiseModalInputLabel: {
    fontSize: '14px',
    fontFamily: font,
    fontWeight: '600',
    color: fieldColor,
    lineHeight: '20px',
    letterSpacing: '0',
    paddingBottom: '6px',
    '& span': {
      fontStyle: 'italic',
    },
  },
  editFranchiseModalInputField: {
    paddingBottom: '24px',
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${onInputHoverPurple}`,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        border: `1px solid ${onInputFocusPurple}`,
      },
    },
    '& div': {
      '& input': {
        '&::placeholder': {
          fontStyle: 'italic',
        },
      },
    },
  },
  editFranchiseModalCancelButton: {
    margin: '0px',
    width: '100%',
    borderRadius: '8px',
    color: buttonPurple,
    textTransform: 'none',
    maxWidth: 'fit-content',
  },
  editFranchiseModalSaveButton: {
    color: 'white',
    padding: '6px 15px',
    borderRadius: '8px',
    textTransform: 'none',
    margin: '0px 0px 0px 12px',
    backgroundColor: buttonPurple,
    '&:disabled': {
      backgroundColor: '#E4E7EC',
      color: '#929FB4',
    },
    '&:hover': {
      color: 'white',
      backgroundColor: onHoverButtonPurple,
    },
  },
}));

export default editFranchiseModalStyles;
